import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Decoder from "@/pages/Decoder";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import PaymentResult from "@/pages/PaymentResult";
import { AuthProvider, useAuth } from "@/context/AuthContext";

const Home = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#09090B]" />;
  return user ? <Decoder /> : <Landing />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-[#09090B] min-h-screen text-white">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#18181B", border: "1px solid rgba(16,185,129,0.3)", color: "#fff",
            borderRadius: "2px", fontFamily: "'Azeret Mono', monospace", fontSize: "12px",
          },
        }}
      />
    </div>
  );
}

export default App;
